import * as React from 'react'

import { Dropdown, DropdownProps } from 'components/Dropdown/Dropdown'

interface DropdownStateProps {
  tab: number | null
}

class StateDropdown extends React.Component<DropdownProps, DropdownStateProps> {
  constructor(props: DropdownProps) {
    super(props)
    this.state = {
      tab: null,
    }
  }

  public render() {
    return (
      <Dropdown
        name={this.props.name}
        value={this.state.tab === null ? undefined : this.state.tab}
        onChange={this.handleChange}
      >
        {this.renderChildren()}
      </Dropdown>
    )
  }

  private handleChange = (value: any, checked: boolean) => {
    this.setState({
      tab: checked ? value : null,
    })
  }

  private renderChildren = () => {
    return React.Children.map(this.props.children, (child, index) => {
      const childElement = child as React.ReactElement<any>
      return React.cloneElement(childElement, {
        checked:
          this.state.tab !== null &&
          this.state.tab.toString() === index.toString(),
      })
    })
  }
}

export default StateDropdown
